import { useRef } from 'react'

import type { AgGridReact } from 'ag-grid-react'
import type { ReactElement } from 'react'

import columns from './columns'

import TableWrapper from '~/components/Tables/TableWrapper'
import { useIapResourceQuery } from '~/queries/iap'

interface Props {
  appId: string
  resourceId: string
}

const IapTable = ({ appId, resourceId }: Props): ReactElement => {
  /** Local state */

  const gridRef = useRef<AgGridReact>(null)

  const tableRef = useRef<HTMLDivElement>(null)

  /** Queries & Mutations */

  const { data: iapResource } = useIapResourceQuery({ appId, resourceId })

  /** Render */

  return (
    <TableWrapper
      className="iap-table"
      columnDefs={columns}
      entriesName="iap"
      includeHiddenColumnsInQuickFilter
      ref={gridRef}
      rowData={iapResource}
      suppressRowHoverHighlight
      tableRef={tableRef}
      withPagination={false}
      withSearchBar
    />
  )
}

export default IapTable
